// src/services/dashboardLayoutService.js
// Per-user dashboard chart-layout preferences (backend transport).
// Shape: { w1: { lg: { cardId: { x, y, w, h, hidden } }, md: {...}, ... }, ...w5 }
import api from '../api/apiClient';

const BASE_PATH = '/users/me/preferences/dashboard-layout';

const dashboardLayoutService = {
  getDashboardLayout: async () => {
    const response = await api.get(BASE_PATH);
    return response;
  },

  saveDashboardLayout: async (layout) => {
    const response = await api.put(BASE_PATH, layout || {});
    return response;
  }
};

export default dashboardLayoutService;
